import React from 'react';
import { Linkedin, Instagram } from 'lucide-react';

export default function Footer() {
    return (
        <footer className="bg-slate-800 text-slate-200 py-12">
            <div className="max-w-6xl mx-auto px-6">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-6 md:mb-0">
                        <h3 className="text-2xl font-bold text-white mb-2">Luciano Argolo</h3>
                        <p className="text-slate-300">Data Engineer y Educador</p>
                        <p className="text-sm text-slate-400 mt-2">
                            Transformando carreras profesionales, una persona a la vez.
                        </p>
                    </div>

                    <div className="flex space-x-6 items-center">
                        <a
                            href="https://www.linkedin.com/in/luciano-argolo/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-slate-400 hover:text-white transition-colors"
                        >
                            <Linkedin className="w-6 h-6" />
                        </a>
                        <a
                            href="https://www.instagram.com/lucianoargolo22/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-slate-400 hover:text-white transition-colors"
                        >
                            <Instagram className="w-6 h-6" />
                        </a>
                        <a
                            href="https://www.tiktok.com/@lucianoargolo0"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-slate-400 hover:text-white transition-colors font-bold text-lg w-6 h-6 flex items-center justify-center"
                        >
                            TT
                        </a>
                    </div>
                </div>

                <div className="border-t border-slate-600 mt-8 pt-8 text-center text-slate-400">
                    <p>&copy; {new Date().getFullYear()} Luciano Argolo. Todos los derechos reservados.</p>
                    <p className="text-sm mt-2">
                        <strong>Tu carrera como Data Engineer empieza con una sola decisión.</strong>
                    </p>
                    <p className="text-sm mt-2">
                        Contacto: <a href="mailto:LucianoAgustinArgolo@gmail.com" className="text-blue-400 hover:text-blue-300">LucianoAgustinArgolo@gmail.com</a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
